import { createAction } from '@reduxjs/toolkit';

import {
  CREATE_MAPPING_FAILURE,
  CREATE_MAPPING_RESET,
  CREATE_MAPPING_START,
  CREATE_MAPPING_SUCCESS,
} from './createMapping.const';

export const createMappingResetAction = createAction(CREATE_MAPPING_RESET);

export const createMappingStartAction = createAction(CREATE_MAPPING_START);
export const createMappingSuccessAction = createAction(CREATE_MAPPING_SUCCESS);
export const createMappingFailureAction = createAction(CREATE_MAPPING_FAILURE);
